/**
 * @ngdoc directive
 * @name newslist
 *
 * @description
 * List of last news
 */
module.directive('newslist', function () {
    'use strict';
    return {
        restrict: 'E',
        scope: {
            label: '@',
            limit: '=',
            showdate: '@',
            showmore: '@',
            step: '@'
        },
        controller: ['$scope', 'drupal', '$filter', function ($scope, drupal, $filter) {
            $scope.loading = true;
            $scope.news = [];

            if (!$scope.step) {
                $scope.step = 1;
            }

            $scope.labeldisplaymore = 'Afficher les ' + $scope.step + ' actualités suivantes';
            $scope.labelempty = 'Aucune actualité à afficher';
            $scope.labelmore = 'Lire la suite';

            drupal.getNodes(['c_actualite']).then(function (news) {
                $scope.news = news.map(function (article) {
                    article.created = article.created * 1000;
                    article.state = 'newsdetail({id: ' + article.nid + ', slug:\'' + $filter('slugify')(article.title) + '\'})';
                    return article;
                });
            }).finally(function () {
                $scope.loading = false;
            });

            $scope.showPlus = function () {
                $scope.limit += $scope.step;
            };
            $scope.showBtn = function () {
                return !$scope.loading && ($scope.showmore === 'true') && $scope.limit < $scope.news.length;
            };
        }],
        template:
                '<div class="aqua-newslist" ng-if="!loading">' +
                '  <div class="grid-main">' +
                '    <h2 class="grid grid-center"><span class="aqua-newslist--title">{{label}}</span></h2>' +

                '    <div class="aqua-newslist--items grid grid-v grid-gutter">' +

                '      <article ng-repeat="article in news | limitTo:limit" content="article" labelmore="{{labelmore}}" showdate="{{showdate}}"></article>' +

                '      <div class="grid grid-center"><button class="aqua-newslist--more" ng-click="showPlus()" ng-show="showBtn()">{{labeldisplaymore}}</button></div>' +
                '      <div ng-if="!loading && news.length == 0" class="aqua-newspage--empty l-tac">{{labelempty}}</div>' +
                '    </div>' +

                '  </div>' +
                '</div>'
    };
});